module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic5.c1e0809.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic5.png
// module id = 484
// module chunks = 1